var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgGoogle = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 160 160"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#4285f4",
  d: "M158.3 81.8a92.687 92.687 0 0 0-1.267-15.133H81.7v30.066h43.133a37.14 37.14 0 0 1-16 23.867v20h25.734c15.066-13.933 23.733-34.467 23.733-58.8Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#34a853",
  d: "M81.7 160c21.6 0 39.667-7.2 52.867-19.4l-25.734-20c-7.2 4.8-16.333 7.733-27.133 7.733-20.867 0-38.533-14.066-44.867-33.066H10.3v20.6A79.88 79.88 0 0 0 81.7 160Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fbbc05",
  d: "M36.833 95.267A46.424 46.424 0 0 1 34.3 80a48.229 48.229 0 0 1 2.533-15.267v-20.6H10.3a79.092 79.092 0 0 0 0 71.734Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#ea4335",
  d: "M81.7 31.667a43.404 43.404 0 0 1 30.667 12l22.8-22.8C121.367 7.933 103.3 0 81.7 0a79.88 79.88 0 0 0-71.4 44.133l26.533 20.6c6.334-19 24-33.066 44.867-33.066Z"
})));

export default SvgGoogle;